module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"oops":"Ups!","accept":"Aceptar"},"en":{"oops":"Oops!","accept":"Accept"}}')
  delete Component.options._Ctor
}
